import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.states';
import { UsersService } from 'src/app/features/users/services/users.service';
import { UsersActions } from 'src/app/features/users/state/users.action-types';
import { UsersSelectors } from 'src/app/features/users/state/users.selector-types';

@Component({
  selector: 'app-new-contract-popup',
  templateUrl: './new-contract-popup.component.html',
  styleUrls: ['./new-contract-popup.component.scss'],
})
export class NewContractPopupComponent implements OnInit, OnDestroy {
  ngUnsubscribe: Subject<void> = new Subject<void>();
  profile: any;
  contractUrl: string = 'https://finsmart.pe/legal';

  constructor(
    private store: Store<AppState>,
    private usersService: UsersService,
    public dialogRef: MatDialogRef<NewContractPopupComponent>
  ) {}

  ngOnInit(): void {
    this.store
      .select(UsersSelectors.profile())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(profile => {
        if (profile) {
          this.profile = profile;
        }
      });
  }

  close(): void {
    this.markContractAsSeen();
  }

  private markContractAsSeen(): void {
    this.usersService.markContractAsSeen().subscribe({
      next: () => {
        this.store.dispatch(UsersActions.LoadProfile());
        this.dialogRef.close();
      },
      error: () => {
        this.dialogRef.close();
      },
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
